export default function Progress({ value, className = "" }) {
  return (
    <div
      className={`w-full bg-gray-300 rounded-full overflow-hidden ${className}`}
      style={{
        height: "12px",
        marginTop: "8px",
        marginBottom: "8px",
      }}
    >
      <div
        className="h-full transition-all duration-300"
        style={{
          width: `${value}%`,
          minWidth: "4px",
          backgroundColor: "#2f2301",      // ← 色を茶色に
        }}
      />
    </div>
  );
}
